import { UserShort } from '@root/entities/user-short'
import { WalletAddress } from '@root/entities/wallet'

import type { UserCheckInviterListData } from '@blade/trade-api-client'
import type { ReferralCodeStatus } from '@root/entities/user-short'
import type { AvatarsHost } from '@root/shared/models'

export interface Inviter extends UserShort.UserShort {
  wallet: WalletAddress | undefined
  referralsCount: number
  tradingSummary: number
  tradingProfit: number
  followers: number
  following: number
  likesCount: number
  mentionsCount: number
  referralCodeStatus: ReferralCodeStatus | undefined
}

export const fromDto = (
  dto: UserCheckInviterListData,
  avatarsHost: AvatarsHost,
): Inviter => {
  return {
    ...UserShort.fromDto(dto, avatarsHost),
    referralsCount: dto.referralsCount,
    tradingSummary: dto.tradingSummary,
    tradingProfit: dto.tradingProfit,
    followers: dto.followers,
    following: dto.following,
    likesCount: dto.likesCount,
    mentionsCount: dto.mentionsCount,
    wallet: dto.wallet ? WalletAddress(dto.wallet) : undefined,
    referralCodeStatus: dto.referralCodeStatus,
  }
}
